module.exports = __webpack_public_path__ + "static/Reelzi-be268bf2dd9d7776a43a80141257b966.png";